import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss']
})
export class AboutUsComponent implements OnInit {
  yearNowTh = new Date().getFullYear() + 543;
  yearNowEn = new Date().getFullYear();
  resultYear = this.yearNowTh - 2535;

  language = JSON.parse(localStorage.getItem('language'))
  language_flag = localStorage.getItem('language_flag');

  textAboutusdetail = this.language.aboutusdetail1;


  pageTitle: string
  choiceFromSelect: string
  valueDropdown = [
    {
      id: 1,
      value: 'ประวัติความเป็นมาของบริษัท'
    },
    {
      id: 2,
      value: 'คณะกรรมการบริษัท และคณะผู้บริหาร'
    },
    {
      id: 3,
      value: 'โครงสร้างองค์กร'
    }
  ];

  flag: any
  

  constructor() { }

  ngOnInit() {
    this.flag = localStorage.getItem('language_flag');
    this.pageTitle = 'ประวัติความเป็นมาของบริษัท'
    this.choiceFromSelect = 'History'
    this.setYeart();
  }

  setYeart(){
    let text = this.textAboutusdetail.split("||");
    for(let i = 0 ; i < text.length; i++){
      if(text[i] === "yearNow"){
        if(this.language_flag === "th"){
          text[i] = this.yearNowTh;
        }
        else{
          text[i] = this.yearNowEn;
        }
      }
      else if (text[i] === "resultYear"){
        text[i] = this.resultYear;
      }
    }
    this.textAboutusdetail = "";
    for(let i = 0 ; i < text.length; i++){
      this.textAboutusdetail += text[i];
    }
  }


  selectValue(event) {
    if (event === 1) {
      this.choiceFromSelect = 'History'
    } else if (event === 2) {
      this.choiceFromSelect = 'Manager'
    } else if (event === 3) {
      this.choiceFromSelect = 'Organize'
    }
  }

}
